import { render, staticRenderFns } from "./ShareResultsForm.vue?vue&type=template&id=2ea432bc&"
import script from "./ShareResultsForm.vue?vue&type=script&lang=js&"
export * from "./ShareResultsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports